import React from "react";
import "./ProgressBarDynamic.css"; // Ensure you have this CSS file imported
import { useTranslation } from 'react-i18next';


const ProgressBarDynamic = ({ value }) => {
      const { t } = useTranslation();
    
    const getBarColorClass = (value) => {
        return value <= 79 ? "red" : "green";
    };

    const progressValue = Math.min(Math.max(value, 0), 100);
    const remainingPercentage = parseFloat((100 - progressValue).toFixed(2));


    return (
        <div className="progress-bar-wrapper">
            {/* Progress Bar Container */}
            <div className="progress-bar-container">
                {/* Progress */}
                <div
                    className={`progress-bar ${getBarColorClass(progressValue)}`}
                    style={{ width: `${progressValue}%` }}
                ></div>

                {/* Floating Dial */}
                <div
                    className="floating-dial"
                    style={{ left: `${progressValue}%` }}
                >
                    {progressValue}%
                </div>
            </div>

            {/* Profile Completion Information */}
            <p
                className={`profile-info ${progressValue === 0 ? "text-red" : ""
                    }`}
            >
                {remainingPercentage}% {t('informationRequired')}
            </p>
        </div>
    );
};

export default ProgressBarDynamic;
